<script setup lang="ts">
import { useSdk } from '~/sdk';

const router = useRouter();
const localePath = useLocalePath();

const breadcrumbs = computed(() => [
  {
    title: 'Home',
    url: localePath('/'),
  },
  {
    title: 'My Account',
    url: '/my-account/my-profile',
  },
]);

const logout = async () => {
  await useSdk().commerce.logout();
  router.push(localePath('/login'));
};
</script>

<template>
  <VContainer class="py-8">
    <div>
      <Breadcrumbs class="breadcrumbs mb-2" :breadcrumbs="breadcrumbs" />

      <Heading :title="$t('My Account')" tag="h2" className="text-2xl font-bold text-gray-900" />

      <div class="pt-6 pb-24">
        <div class="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-4">
          <ul class="space-y-4 border-b border-gray-200 pb-6 text-sm font-medium text-gray-900">
            <li class="">
              <NuxtLink :to="localePath('/my-account')" class="px-3 py-2 hover:bg-gray-100 block w-full">
                {{ $t('My profile') }}
              </NuxtLink>
            </li>
            <li class="">
              <NuxtLink :to="localePath('/my-account/addresses')" class="px-3 py-2 hover:bg-gray-100 block w-full">
                {{ $t('Addresses') }}
              </NuxtLink>
            </li>
            <li class="">
              <NuxtLink :to="localePath('/my-account/orders')" class="px-3 py-2 hover:bg-gray-100 block w-full">
                {{ $t('Order history') }}
              </NuxtLink>
            </li>
            <li class="">
              <button @click.prevent="logout" type="button" class="px-3 text-left py-2 hover:bg-gray-100 block w-full">
                {{ $t('Logout') }}
              </button>
            </li>
          </ul>
          <div class="col-span-3">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </VContainer>
</template>

<style scoped>
@reference 'tailwindcss';

/* exact link will show the primary color for only the exact matching link */
a.router-link-exact-active {
  @apply bg-gray-100;
}
</style>
